import {
    AfterViewInit,
    Component,
    ElementRef,
    Input,
    OnInit,
    ViewChild,
} from '@angular/core';

@Component({
    selector: 'custom-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent implements AfterViewInit, OnInit {
    @Input() message = '';
    @Input() type: 'Error' | 'Message' = 'Message';
    @Input() duration = 3000;
    @ViewChild('toast') toast: ElementRef<HTMLElement>;
    toastClass = 'toast-alert';

    constructor() {}
    ngOnInit(): void {}
    ngAfterViewInit(): void {}
}
